<template>
  <v-form ref="workplaceForm" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="workplacesSelected"
          :items="workplacesList"
          chips
          outlined
          multiple
          item-value="id"
          item-text="name"
          return-object
          :label="label"
          :rules="[rules.required]"
          @change="saveCompetence"
        >
          <template v-slot:selection="{attrs, item, selected}">
            <v-chip
              class="clear-chips-icon"
              close-icon="$sl-close"
              v-bind="attrs"
              :rules="[rules.required]"
              :input-value="selected"
              close
              @click:close="remove(item)"
              >{{ item.name }}</v-chip
            >
          </template>
        </v-select>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import {RulesMixin} from '@/components/mixins'
import API from '@/services/api.js'
export default {
  name: 'SelectWorkplaces',
  mixins: [RulesMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    companyId: {
      type: Number,
      default: 0
    },
    propWorkplaces: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      workplacesSelected: [],
      workplacesList: [],
      valid: true
    }
  },

  created() {
    if (this.propWorkplaces && this.propWorkplaces.length > 0) {
      this.workplacesSelected = this.propWorkplaces
    }
    this.initialMethod()
  },
  methods: {
    initialMethod() {
      this.fetchWorkplacesList()
    },
    remove(item) {
      this.workplacesSelected.splice(this.workplacesSelected.indexOf(item), 1)
      this.workplacesSelected = [...this.workplacesSelected]
      this.$emit('linked-workplaces', this.workplacesSelected)
    },
    saveCompetence() {
      this.$emit('linked-workplaces', this.workplacesSelected)
    },
    fetchWorkplacesList() {
      API.getWorkplaces(this.companyId)
        .then(res => {
          this.workplacesList = res.data
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>